import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const HeaderBg = styled.div`
background-color: ${colors.light};
margin-bottom: 0px;
`;

export const Title = styled.h4`
color: ${colors.darkGrey};
font-size: 21px;
line-height: 42px;
font-weight: medium;
@media screen and (max-width: 1919px) {
    font-size: 18px;
}
`;

export const StyledBox = styled.div`
@media screen and (max-width: ${ScreenSize.portrait}px) {
    &:nth-of-type(2) {
        margin-top: 20px;
    }
    &:nth-of-type(3) {
        margin-top: 20px;
    }
}
`;
